import { useEffect, useState } from "react";
import { deleteCrmLeadsService, deleteMultipleLeadsService, getCrmDDLService, getCrmLeadsServiceTasklist, updateLeadFollowUpService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { getStaffsService } from "../../../../Services/CRMAdminServices/CRMStaffService";
import { Link } from "react-router-dom";
import { Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import TextField from "../../../common/TextField";
import MobileField, { formatMobile } from "../../../common/MobileField";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import InfiniteScroll from "react-infinite-scroll-component";
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import * as XLSX from "xlsx";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import BootstrapTable from "react-bootstrap-table-next";
import SelectDatePicker from "../../../common/SelectDatePicker";
import { RootState } from '../../../../ReduxToolkit/Store';
import { useSelector } from 'react-redux';

const customStyles = {
    head: {
        style: {
            fontWeight: '800',
            color: '#0000ff',
            fontSize: '14px'
        },
    },
};

const PROPERTY_TOP_3 = "Property Top 3";
const BUSINESS_LOAN = "Business Loan";
const MORTGAGE_MASTERY_PROGRAM = "Mortgage Mastery Program";

type TaskMode = "top3" | "loan" | "mmp";

interface CRMLeadListProps {
    taskMode?: TaskMode;
    pageTitle?: string;
}

const TaskMMP = ({ taskMode = "top3", pageTitle = "Task - Top 3" }: CRMLeadListProps) => {
    // const { RoleName, nameidentifier: userID, FirstName } = useSelector((state: RootState) => state.adminAuth);
    const { RoleName, RoleID, nameidentifier: userID, FirstName } = useSelector((state: RootState) => state.adminAuth);

    console.log("User ID for logged user:", userID, FirstName);
    const isAdmin = RoleName?.toLowerCase() === "admin";
    const [formData, setFormData] = useState({
        leadID: "",
        surname: "",
        mobile: "",
        email: "",
        staff: isAdmin ? "" : userID?.toString() || "",
        source: "",
        checkboxType: 3,
        pageNumber: 1,
        pageSize: 1000,
        followup: '',
        stage: ''
    });

    const [staffs, setStaffs] = useState<any>([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [leads, setLeads] = useState<any>([]);
    const [totalLeads, setTotalLeads] = useState<number>(0);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [selectedLeadsId, setSelectedLeadsId] = useState<any>([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [deleteMultipleModal, setDeleteMultipleModal] = useState(false);
    const navigate = useSafeNavigate();
    const queryClient = useQueryClient();
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [leadDropdownData, setLeadDropdownData] = useState<any>([])

    const filterLeadsByTaskMode = (items: any[]) => {
        if (!Array.isArray(items)) return [];
        if (taskMode === "loan") {
            return items.filter((lead: any) => lead.suburb === BUSINESS_LOAN);
        }
        if (taskMode === "mmp") {
            return items.filter((lead: any) => lead.suburbdigit === MORTGAGE_MASTERY_PROGRAM);
        }
        return items.filter((lead: any) => {
            const hasAnySelection =
                lead.state === PROPERTY_TOP_3 ||
                lead.suburb === BUSINESS_LOAN ||
                lead.suburbdigit === MORTGAGE_MASTERY_PROGRAM;
            return !hasAnySelection || lead.state === PROPERTY_TOP_3;
        });
    };



    useEffect(() => {
        if (!isAdmin && userID) {
            setFormData(prev => ({ ...prev, staff: userID.toString() }));
        }
    }, [isAdmin, userID]);

    const { data: leadsData, isLoading, isError, refetch } = useGetRequestQuery<any>(
        ['getCrmLeads', searchTrigger, formData.pageNumber, formData.pageSize, formData.checkboxType],
        () => getCrmLeadsServiceTasklist(formData) as any,
        {
            enabled: true,
            staleTime: 30000, // Data will be considered fresh for 30 seconds
            cacheTime: 60000, // Cache will be kept for 1 minute
        }
    );

    const { data: leadsDataDDL, isLoading: DDLloading } = useGetRequestQuery<any>(
        ['getCrmDDLService'],
        () => getCrmDDLService(),
        {
            enabled: true,
            staleTime: 30000, // Data will be considered fresh for 30 seconds
            cacheTime: 60000, // Cache will be kept for 1 minute
        }
    );

    // Combine both data loading effects into one
    useEffect(() => {
        if (!isLoading && !DDLloading && !isError) {
            if (leadsData?.data) {
                const filteredLeads = filterLeadsByTaskMode(leadsData.data || []);
                setLeads(filteredLeads);
                setTotalLeads(filteredLeads.length);
            }
            if (leadsDataDDL?.data) {
                setLeadDropdownData(leadsDataDDL.data || []);
            }
            setIsInitialLoad(false);
            // console.log('role',RoleID)
        }
    }, [leadsData, leadsDataDDL, isLoading, DDLloading, isError, taskMode]);

    const handleValueChange = (name: string, value: string | Date | null) => {
        setFormData(prev => ({
            ...prev,
            [name]: value,
            pageNumber: 0
        }));
    };

    // Add debounce function
    const debounce = (func: Function, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        const debouncedFn = (...args: any[]) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func(...args), delay);
        };
        debouncedFn.cancel = () => clearTimeout(timeoutId);
        return debouncedFn;
    };

    // Modify the useEffect for automatic search to only trigger on user input
    useEffect(() => {
        const shouldTriggerSearch = () => {
            const textInputs = ['leadID', 'surname', 'mobile', 'email'];
            const hasEnoughText = textInputs.some(field =>
                formData[field as keyof typeof formData]?.toString().length >= 3
            );

            const dropdowns = ['staff', 'source'];
            const hasDropdownValue = dropdowns.some(field =>
                formData[field as keyof typeof formData] !== undefined
            );

            const wasCleared = textInputs.some(field =>
                formData[field as keyof typeof formData] === ''
            ) || dropdowns.some(field =>
                formData[field as keyof typeof formData] === ''
            );

            return hasEnoughText || hasDropdownValue || wasCleared;
        };

        const debouncedSearch = debounce(() => {
            if (shouldTriggerSearch() && !isInitialLoad) {
                setLeads([]);
                setSearchTrigger(prev => prev + 1);
            }
        }, 800);

        debouncedSearch();

        return () => {
            debouncedSearch.cancel?.();
        };
    }, [formData, isInitialLoad]);

    const handleSearch = () => {
        setLeads([]);
        setFormData(prev => ({ ...prev, pageNumber: 0 }));
        setSearchTrigger((prev) => prev + 1);
    };

    const { mutate: manageUser, isPending: isManageUserPending } = useMutationRequestQuery("manageUser", deleteCrmLeadsService, {
        onSuccess: () => {
            toast.success("Lead deleted successfully.");
            queryClient.invalidateQueries({ queryKey: ["getCrmLeads"] });
            refetch();
            setDeleteModal(false);
        },
        onError: () => {
            toast.error("Failed to delete lead.");
            setDeleteModal(false);
        },
    });

    const confirmDelete = (id: number) => {
        setSelectedUserId(id);
        setDeleteModal(true);
    };

    const handleDeleteClick = () => {
        if (selectedUserId) {
            manageUser(selectedUserId);
        }
    };

    const { mutate: deleteLeads, isPending: isDeleting } = useMutationRequestQuery(
        "deleteMultipleLeads",
        deleteMultipleLeadsService,
        {
            onSuccess: () => {
                toast.success("Leads deleted successfully.");
                refetch()
                setToggleCleared(true)
                setDeleteMultipleModal(false);
                setSelectedLeadsId([]);
            },
            onError: () => {
                toast.error("Failed to delete leads.");
            }
        }
    );

    const handleDeleteSelectedLeads = () => {
        if (selectedLeadsId.length === 0) {
            toast.error("No leads selected.");
            return;
        }
        setDeleteMultipleModal(true);
    };

    const confirmDeleteMultipleLeads = () => {
        deleteLeads(selectedLeadsId);
    };

    const { mutate: updateFollowUp, isPending: isUpdating } = useMutationRequestQuery(
        "updateLeadFollowUp",
        updateLeadFollowUpService,
        {
            onSuccess: () => {
                toast.success("Follow-up date updated.");
                refetch()
                setFormData({ ...formData, followup: '' })
                setSelectedLeadsId([])
            },
            onError: () => {
                toast.error("Failed to update follow-up date.");
            }
        }
    );

    const handleUpdateFollowUp = () => {
        if (!formData.followup || selectedLeadsId.length === 0) {
            toast.error("Select a follow-up date and at least one lead.");
            return;
        }
        // Format the date to ISO string with time set to 14:00:00
        const followupDate = new Date(formData.followup);
        followupDate.setHours(14, 0, 0, 0);
        const formattedDate = followupDate.toISOString();
        updateFollowUp({ date: formattedDate, data: selectedLeadsId });
    };

    const leadColumns = [
        {
            dataField: "followUp",
            text: "Followup",
            formatter: (cell: string) => {
                if (!cell) return "";
                const followUpDate = new Date(cell);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                let color = "#008000";
                if (followUpDate <= today) {
                    color = "red";
                } else if (followUpDate.getTime() === today.getTime()) {
                    color = "red";
                }
                return (
                    <span style={{ color, fontWeight: "bold" }}>
                        {followUpDate.toLocaleDateString("en-GB")}
                    </span>
                );
            },
            headerStyle: { width: "6rem", color: "#0000ff" },
        },
        {
            dataField: "leadID",
            text: "ID",
            headerStyle: { width: "3rem", color: "#0000ff" },
            style: (cell: any, row: any) => {
                if (!row.followUp) return {};
                const followUpDate = new Date(row.followUp);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return {
                    color: followUpDate <= today ? 'red' : 'green'
                };
            }
        },
        {
            dataField: "staff",
            text: "Staff",
            headerStyle: { width: "4rem", color: "#0000ff" },
            style: (cell: any, row: any) => {
                if (!row.followUp) return {};
                const followUpDate = new Date(row.followUp);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return {
                    color: followUpDate <= today ? 'red' : 'green'
                };
            }
        },
        {
            dataField: "stage",
            text: "Stage",
            headerStyle: { width: "10rem", color: "#0000ff" },
            style: (cell: any, row: any) => {
                if (!row.followUp) return {};
                const followUpDate = new Date(row.followUp);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return {
                    color: followUpDate <= today ? 'red' : 'green'
                };
            }
        },
        
        {
            dataField: "surname",
            text: "Surname",
            formatter: (cell: string, row: any) => (
                <Link to={`/EditLead/${row.leadID}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {cell ? cell.toUpperCase() : ""}
                </Link>
            ),
            headerStyle: { width: "13rem", color: "#0000ff" },
            style: (cell: any, row: any) => {
                if (!row.followUp) return {};
                const followUpDate = new Date(row.followUp);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return {
                    color: followUpDate <= today ? 'red' : 'green',
                    cursor: 'pointer'
                };
            }
        },
        {
            dataField: "firstName",
            text: "First Name",
            formatter: (cell: string) => cell ? cell.charAt(0).toUpperCase() + cell.slice(1).toLowerCase() : "",
            headerStyle: { width: "8rem", color: "#0000ff" },
            style: (cell: any, row: any) => {
                if (!row.followUp) return {};
                const followUpDate = new Date(row.followUp);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return {
                    color: followUpDate <= today ? 'red' : 'green'
                };
            }
        },
        {
            dataField: "mobile",
            text: "Mobile",
            headerStyle: { width: "9.5rem", color: "#0000ff" },
            style: (cell: any, row: any) => {
                if (!row.followUp) return {};
                const followUpDate = new Date(row.followUp);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return {
                    color: followUpDate <= today ? 'red' : 'green'
                };
            }
        },
        {
            dataField: "latestComment",
            text: "Comments",
            formatter: (cell: string) => (
                <div>
                    {cell}
                </div>
            ),
            headerStyle: { minWidth: "22rem", color: "#0000ff", overflow: "hidden", textOverflow: "ellipsis" },
            style: (cell: any, row: any) => {
                if (!row.followUp) return {};
                const followUpDate = new Date(row.followUp);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return {
                    color: followUpDate <= today ? 'red' : 'green'
                };
            }
        },
        {
            dataField: "actions",
            text: "Action",
            formatter: (_: any, row: any) => (
                <ul className="action simple-list d-flex flex-row">
                    <li className="edit">
                        <Link to={`/EditLead/${row.leadID}`}>
                            <i className="icon-pencil-alt" />
                        </Link>
                    </li>
                    {isAdmin ? <li className="delete" style={{ marginLeft: "10px" }}>
                        <a onClick={() => confirmDelete(row.leadID)}>
                            <i className="icon-trash" />
                        </a>
                    </li> : null}
                </ul>
            ),
            headerStyle: { width: '7rem', color: "#0000ff" },
        }
    ];

    const handleDownloadExcel = () => {
        if (!leads.length) {
            toast.warning("No lead data available to download.");
            return;
        }
        const excelData = leads.map((row: any) => ({
            "Lead Number": row.leadID,
            "First Name": row.firstName,
            "Surname": row.surname,
            "Mobile": formatMobile(row.mobile),
            "Email": row.email,
            "Staff": row.staff
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        worksheet["!cols"] = [
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 30 },
            { wch: 15 }
        ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Leads Data");
        XLSX.writeFile(workbook, "Leads_Data.xlsx");
    };
    const selectRow = {
        headerColumnStyle: {
            // width: '30px',
            // minWidth: '40px',
            position: 'absolute',
            right: '0'
        },
        selectColumnStyle: {
            // width: '40px',
            // minWidth: '40px',
            position: 'absolute',
            right: '0'
        },
        mode: "checkbox",  // Use checkboxes to select rows
        clickToSelect: true,  // Allow row selection on click
        selected: selectedLeadsId,  // Array containing selected lead IDs
        hideSelectAll: true,  // Hide the "Select All" checkbox in the header
        selectionRenderer: ({ checked, disabled }: { checked: boolean; disabled: boolean }) => (
            isAdmin ? (<input
                type="checkbox"
                checked={checked}
                disabled={disabled}
            // style={{ marginLeft: '10px' }}

            />) : null
        ),
        onSelect: (row: any, isSelect: boolean) => {
            setSelectedLeadsId((prev: any) =>
                isSelect ? [...prev, row.leadID] : prev.filter((id: any) => id !== row.leadID)
            );
        },
        onSelectAll: (isSelect: boolean, selectedRows: any) => {
            const selectedIds = selectedRows.map((row: any) => row.leadID);
            setSelectedLeadsId(isSelect ? selectedIds : []);
        },
        style: { width: '20px', height: '20px' }
    };

    return (
        <div className="px-4 pt-4" style={{
            height: '100vh',
            overflow: 'hidden',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <div style={{
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '10px',
                backgroundColor: '#fff',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            }}>
                <div className="g-3 mb-2 d-flex justify-content-between align-items-center">
                    <h3 className="f-w-900 heading-color mx-3 py-2">{pageTitle}</h3>
                    <h3 className="f-w-900 heading-color mx-3" style={{ minWidth: '150px', textAlign: 'right' }}>
                        Total Leads {isInitialLoad ? '-' : totalLeads}
                    </h3>
                    {RoleID !== '2' ? (
                        <Button color="primary" className="mx-3" onClick={() => navigate("/AddLead")}>
                            Add Lead
                        </Button>
                    ) : (
                        <Button color="primary" className="mx-3 invisible" style={{ visibility: 'hidden' }}>
                            Add Lead
                        </Button>
                    )}

                </div>
                <Row className="mt-4">
                    <div className="d-md-flex item-center mt-2">
                        <Col className="responsive-col-lead" xs={12} style={{ width: '4.5%', paddingInline: '2px' }}>
                            <Label className="mt-2">Lead ID:</Label>
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                            <TextField
                                label=""
                                type="text"
                                name="leadID"
                                value={formData.leadID}
                                setValue={handleValueChange}
                                placeholder=""
                                design="flex"
                                passCol="col-11"
                                maxChars={6}
                                tabIndex={1}
                                showClearIcon={true}
                                autoComplete="off"
                            />
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '4.7%', paddingInline: '2px' }}>
                            <Label className="mt-2">Surname:</Label>
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '11%', paddingInline: '2px' }}>
                            <TextField
                                label=""
                                type="text"
                                name="surname"
                                value={formData.surname}
                                setValue={handleValueChange}
                                placeholder=""
                                design="flex"
                                passCol="col-11"
                                maxChars={15}
                                tabIndex={2}
                                showClearIcon={true}
                                autoComplete="off"
                            />
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '3.7%', paddingInline: '2px' }}>
                            <Label className="mt-2">Mobile:</Label>
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '12%', paddingInline: '2px' }}>
                            <MobileField
                                label=""
                                mobileField="mobile"
                                value={formData.mobile}
                                setValue={handleValueChange}
                                placeholder="Mobile"
                                design="flex"
                                passCol="col-11"
                                maxLength={18}
                                tabIndex={3}
                                showClearIcon={true}
                                autoComplete="off"
                            />
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '3%', paddingInline: '2px' }}>
                            <Label className="mt-2">Email:</Label>
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '18%', paddingInline: '2px' }}>
                            <TextField
                                label=""
                                type="email"
                                name="email"
                                value={formData.email}
                                setValue={handleValueChange}
                                placeholder=""
                                design="flex"
                                passCol="col-11"
                                maxChars={40}
                                tabIndex={4}
                                showClearIcon={true}
                                autoComplete="off"
                            />
                        </Col>
                        {(RoleID === '1') && (

                            <Col className="responsive-col-lead" xs={12} style={{ width: '3%', paddingInline: '2px' }}>
                                <Label className="mt-2">Staff:</Label>
                            </Col>
                        )}
                        {(RoleID === '1') && (
                            <Col className="responsive-col-lead" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                <DropdownWithValueName
                                    label=""
                                    name="staff"
                                    value={formData.staff}
                                    setValue={handleValueChange}
                                    options={leadDropdownData?.staff || []}
                                    required={true}
                                    tabIndex={5}
                                    passCol="col-10"
                                />
                            </Col>
                        )}
                        <Col className="responsive-col-lead" xs={12} style={{ width: '3.7%', paddingInline: '2px' }}>
                            <Label className="mt-2">Source:</Label>
                        </Col>
                        <Col className="responsive-col-lead" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                            <DropdownWithValueName
                                label=""
                                name="source"
                                value={formData.source}
                                setValue={handleValueChange}
                                options={leadDropdownData?.leadSources || []}
                                required={true}
                                tabIndex={6}
                                passCol="col-10"
                            />
                        </Col>
                        <Button onClick={handleSearch} style={{ fontSize: '16px' }} className="text-center mb-3" color="success">
                            Search Now
                        </Button>
                    </div>
                </Row>
                {/*<Row className="mt-2">
                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center me-4">
                            <Link
                                to="/BulkSMSTaskList"
                                className="btn btn-outline-primary mb-3 mx-1"
                            >
                                SMS
                            </Link>
                            <Link
                                to="/BulkChange"
                                className="btn btn-outline-primary mb-3 mx-1"
                            >
                                Lead
                            </Link>
                            <Link
                                to="/BulkstaffChange"
                                className="btn btn-outline-primary mb-3 mx-1"
                            >
                                Staff
                            </Link>
                            <Link
                                to=""
                                onClick={handleDownloadExcel}
                                className="btn btn-outline-primary mb-3 mx-1"
                            >
                                CSV
                            </Link>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center me-3">
                                <Label className="mb-3 me-2">Date:</Label>
                                <SelectDatePicker
                                    label=""
                                    name="followup"
                                    value={formData.followup}
                                    setValue={handleValueChange}
                                    design="flex"
                                    tabIndex={7}
                                />
                            </div>
                            <Button color="primary" className="mb-3 me-2" outline onClick={handleUpdateFollowUp}>Update Followup</Button>
                            <Button color="danger" className="mb-3" outline onClick={handleDeleteSelectedLeads}>Delete Leads</Button>
                        </div>
                    </div>
                </Row>*/}
                {isAdmin && (
                    <Row className="mt-2">
                        <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center me-4">
                                <Link
                                    to="/BulkSMSTaskList"
                                    className="btn btn-outline-primary mb-3 mx-1"
                                >
                                    SMS
                                </Link>
                                <Link
                                    to="/BulkChange"
                                    className="btn btn-outline-primary mb-3 mx-1"
                                >
                                    Lead
                                </Link>
                                <Link
                                    to="/BulkstaffChange"
                                    className="btn btn-outline-primary mb-3 mx-1"
                                >
                                    Staff
                                </Link>
                                <Link
                                    to=""
                                    onClick={handleDownloadExcel}
                                    className="btn btn-outline-primary mb-3 mx-1"
                                >
                                    CSV
                                </Link>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="d-flex align-items-center me-3">
                                    <Label className="mb-3 me-2">Date:</Label>
                                    <SelectDatePicker
                                        label=""
                                        name="followup"
                                        value={formData.followup}
                                        setValue={handleValueChange}
                                        design="flex"
                                        tabIndex={7}
                                    />
                                </div>
                                <Button color="primary" className="mb-3 me-2" outline onClick={handleUpdateFollowUp}>Update Followup</Button>
                                <Button color="danger" className="mb-3" outline onClick={handleDeleteSelectedLeads}>Delete Leads</Button>
                                    {selectedLeadsId.length > 0 && (
                                        <span 
                                            className="d-inline-flex align-items-center ms-2 mb-3" 
                                            style={{ 
                                                fontSize: '14px', 
                                                padding: '6px 12px', 
                                                border: '1px solid #0052cc',
                                                borderRadius: '50px',
                                                backgroundColor: '#e6f0fa',
                                                color: '#0052cc',
                                                fontWeight: 'bold',
                                                verticalAlign: 'middle'
                                            }}
                                        >
                                            Selected: {selectedLeadsId.length}
                                            <i 
                                                className="icon-brush ms-2" 
                                                style={{ 
                                                    cursor: 'pointer', 
                                                    color: '#ff3f3f', 
                                                    fontSize: '16px',
                                                    transition: 'transform 0.2s, color 0.2s'
                                                }} 
                                                onClick={() => setSelectedLeadsId([])}
                                                title="Deselect all"
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.color = '#cc0000';
                                                    e.currentTarget.style.transform = 'scale(1.15)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.color = '#ff3f3f';
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                }}
                                            />
                                        </span>
                                    )}
                            </div>
                        </div>
                    </Row>
                )}

                {(isLoading || isInitialLoad || DDLloading) ? (
                    <div style={{
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        padding: "12px",
                        backgroundColor: "#fff",
                        textAlign: "center",
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }} className='mt-4 mb-2'>
                        <Spinner color="primary" />
                    </div>
                ) : leads.length !== 0 ? (
                    <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        position: 'relative',
                        marginTop: '20px',
                        marginLeft: '-2.5rem'
                    }}>
                        <div style={{ backgroundColor: "#fff", width: "100%", overflowX: "auto" }}>
                            <BootstrapTable
                                keyField="leadID"
                                data={leads}
                                columns={leadColumns as any}
                                selectRow={selectRow as any}
                                bordered={false}
                                wrapperClasses="table-responsive"
                                noDataIndication="No leads found"
                            />
                        </div>
                    </div>
                ) : (
                    <div style={{
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        padding: "12px",
                        backgroundColor: "#fff",
                        textAlign: "center",
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }} className='mt-4 mb-2'>
                        <h6>No Leads data available.</h6>
                    </div>
                )}
            </div>

            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} centered>
                <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>Confirm Delete</ModalHeader>
                <ModalBody>Are you sure you want to delete the selected lead?</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                    <Button color="danger" onClick={handleDeleteClick} disabled={isManageUserPending}>
                        {isManageUserPending ? "Deleting..." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteMultipleModal} toggle={() => setDeleteMultipleModal(!deleteMultipleModal)} centered>
                <ModalHeader toggle={() => setDeleteMultipleModal(!deleteMultipleModal)}>Confirm Delete</ModalHeader>
                <ModalBody>Are you sure you want to delete the selected {selectedLeadsId.length} leads?</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setDeleteMultipleModal(false)}>Cancel</Button>
                    <Button color="danger" onClick={confirmDeleteMultipleLeads} disabled={isDeleting}>
                        {isDeleting ? "Deleting..." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default TaskMMP;
